import { ai2htmlResize } from './utils/ai2html-resizer';

// ai2htmlResize('#g-legend-box');
ai2htmlResize('#g-2025-box');
